import request from '@/utils/request'

// 注册
export function bidCompanyRegister(data) {
  return request({
    url: '/bidCompany/register',
    method: 'post',
    data: data  
 })
}
// 登录
export function login(data) {
  return request({
    url: '/login',
    method: 'post',
    data: data  
  })
}
// 获取短信验证码
export function smsSender(data) {
  return request({
    url: '/smsSender',
    method: 'post',
    data: data  
  })
}
// 获取个人信息
export function profileGetInfo() {
  return request({
    url: '/system/user/profile/getInfo',
    method: 'get',
  })
}
// 修改个人信息
export function profileUpdateInfo(data) {
  return request({
    url: '/system/user/profile/updateInfo',
    method: 'post',
    data: data  
  })
}
// 修改密码
export function profileUpdatePwd(data) {
  return request({
    url: '/system/user/profile/updatePwd',
    method: 'put',
    params:data
  })
}
// 获取图片验证码
export function captchaImage() {
  return request({
    url: '/captchaImage',
    method: 'get',
  })
}
// 忘记密码身份认证
export function identityVerification(data) {
  return request({
    url: '/bidCompany/identityVerification',
    method: 'post',
    data: data  
  })
}
// 重置密码
export function bidCompanyResetPwd(data) {
  return request({
    url: '/bidCompany/resetPwd',
    method: 'post',
    data: data  
  })
}
// 推出登录
export function logout() {
  return request({
    url: '/logout',
    method: 'get',
  })
}
//邮箱验证码
export function smsSendEmail(data) {
  return request({
    url: '/smsSendEmail',
    method: 'post',
    params: data,
    timeout: 20000
  })
}